import * as React from 'react';
import FocusMatch from "../../containers/FocusMatch";
import StatisticsVideoArea from "./Components/StatisticsVideoArea";

// focusMatchLayout - for LMT
const FocusMatchLayout = () => {
    return (
        <div className="defaultGuiWrapper focusmatchlayout">
            <FocusMatch>
                <div className="sr-grid sr-row-sr-align-center guiHeader">
                    <div className="sr-cell sr-xs-1-5 sr-show-up-to-m">
                        <div className="sr-content">
                            <div></div>
                        </div>
                    </div>
                </div>
                <div className="sr-grid guiContent">
                    <div className="sr-cell videoWrapper">
                        <div className="sr-content sr-align-center">
                            <div className="videoContent sr-content">
                                <StatisticsVideoArea showPlayerProfiles={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </FocusMatch>
        </div>
    )
}

export default FocusMatchLayout;
